<template>
  <el-dialog
    :title="$t('pages.equipment.text318')"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div>
      <div id="form-body">
        <el-form
          :model="macForm"
          ref="macForm"
          label-width="auto">
          <el-form-item label="MAC地址">
            <el-input v-model="macForm.fingerMac"/>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("button.close") }}</el-button>
      <el-button type="primary" @click="fingerMacChange">{{$t("button.determine")}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      macForm: {
        bikeCode: "", //车辆编码
        fingerMac: "", //Mac地址
      },
    };
  },
  watch: {
    dialogVisible(newValue) {
      if (newValue) {
        this.macForm.bikeCode = this.bikeCode;
        this.macForm.fingerMac = this.fingerMac;
      }
    },
  },
  components: {},
  props: ["dialogVisible","fingerMac","bikeCode"],
  methods: {
    handleClose() {
      this.$emit("fingerMacClose");
    },
    fingerMacChange() {
      this.$emit("fingerMacChange",this.macForm.fingerMac);
    },
  },
};
</script>

<style scoped>
#form-body {
  padding: 0 40px;
  box-sizing: border-box;
  width: 80%;
}
</style>